import {
  Edit,
  SimpleForm,
  NumberInput,
  TextInput,
  DateInput,
  SelectInput,
  required,
  minValue,
} from "react-admin";
import type { EditProps } from "react-admin";
import { PAYMENT_MODE_CONST } from "@/constants";

const paymentChoices = Object.entries(PAYMENT_MODE_CONST).map(([id, name]) => ({ id, name }));

export const ProjectTakhmeenReceiptEdit = (props: EditProps) => (
  <Edit
    {...props}
    transform={(data: Record<string, unknown>) => ({
      amount: Number(data.amount),
      paymentMode: data.paymentMode,
      paymentRef:
        typeof data.paymentRef === "string" ? data.paymentRef.trim() || undefined : data.paymentRef,
      receiptDate: data.receiptDate,
      remarks: typeof data.remarks === "string" ? data.remarks.trim() || undefined : data.remarks,
    })}
  >
    <SimpleForm>
      <NumberInput source="amount" validate={[required(), minValue(1)]} />
      <SelectInput source="paymentMode" choices={paymentChoices} validate={required()} />
      <TextInput source="paymentRef" fullWidth />
      <DateInput source="receiptDate" />
      <TextInput source="remarks" multiline fullWidth />
    </SimpleForm>
  </Edit>
);
